var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsUUID } from 'class-validator';
import { OfficeLocationStatsDto } from './office-location-stats.dto.js';
import { OfficeLocationStub } from './office-location-stub.dto.js';
export class OfficeLocationStatsFullSizeDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    officeLocation;
    totalStats;
    monthlyStats;
    weeklyStats;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationStatsFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationStatsFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationStatsFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationStatsFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeLocationStub),
    Expose(),
    __metadata("design:type", Function)
], OfficeLocationStatsFullSizeDto.prototype, "officeLocation", void 0);
__decorate([
    IsObject(),
    Expose(),
    Type(() => OfficeLocationStatsDto),
    __metadata("design:type", OfficeLocationStatsDto)
], OfficeLocationStatsFullSizeDto.prototype, "totalStats", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeLocationStatsDto),
    Expose(),
    __metadata("design:type", OfficeLocationStatsDto)
], OfficeLocationStatsFullSizeDto.prototype, "monthlyStats", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeLocationStatsDto),
    Expose(),
    __metadata("design:type", OfficeLocationStatsDto)
], OfficeLocationStatsFullSizeDto.prototype, "weeklyStats", void 0);
//# sourceMappingURL=office-location-stats.full-size.dto.js.map